import React, { useRef, useState, useEffect } from "react";
import { TextInput, Checkbox } from "../form/inputs";
import UploadTriggerCard from "../upload/UploadTriggerCard";
import UploadIcon from "../../assets/images/svgs/other/Uploadicon.svg";
import GalleryImg from "../../assets/images/svgs/other/uploadImg.svg";
import { Tooltip } from "react-tooltip";
import { CiCircleInfo } from "react-icons/ci";
import { GoSun } from "react-icons/go";
import { BsMoonStars } from "react-icons/bs";
import ToggleBtn from "../button/ToggleBtn";
import { MdDeleteOutline, MdAdd } from "react-icons/md";
import PrimaryBtn from "../button/PrimaryBtn";
import SecondaryBtn from "../button/SecondaryBtn";
import DecorativeSquares from "../ui/DecorativeSquares";
import { FaArrowLeft } from "react-icons/fa";
import InputBase from "../form/inputs/InputBase";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import TimeRangePicker12 from "../ui/TimeRangePicker12";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import SortableImageItem from "../upload/SortablleImageItem";
import {
  addNewExtraItem,
  addNewImages,
  addOrUpdateMealDetail,
  getAllMeals,
  getExtraItems,
  getMealDetailById,
  isExtraItemChecked,
} from "../../redux/thunks/mealsetupThunk";
import { useDispatch, useSelector } from "react-redux";
import ExtraItemsModalShimmer from "../Preloader/ExtraItemsModalShimmer";
import MealUploadLibraryModal from "./MealUploadLibraryModal";
import { decryptId } from "../../utils/urlCrypto";

const EditMeal = ({ onSave, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { mealId } = useParams();
  const meal_id = decryptId(mealId);
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [showLibrary, setShowLibrary] = useState(false);
  const fileInputRef = useRef(null);
  const [showAddInline, setShowAddInline] = useState(false);
  const [weekly, setWeekly] = useState([]);
  const [monthly, setMonthly] = useState([]);
  const [selectedExtraIds, setSelectedExtraIds] = useState([]);
  const currencySymbol = localStorage.getItem("currency");
  const { isMealLoading } = useSelector((state) => state.setMeal);
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const addExtraItem = () => {
    if (!newExtra.name || !newExtra.price) return;

    const newItem = {
      name: newExtra.name,
      price: newExtra.price,
      selected: false,
    };

    setExtraItems((prev) => [...prev, newItem]);

    // reset fields
    setNewExtra({ name: "", price: "" });

    // hide form
    setShowAddInline(false);
  };

  const closeModal = () => {
    setShowExtraModal(false);
    setShowAddInline(false);
    setNewExtra({ name: "", price: "" });
  };

  const [dayToggle, setDayToggle] = useState(
    days.reduce((acc, day) => ({ ...acc, [day]: false }), {}),
  );

  const [foodType, setFoodType] = useState(() =>
    days.reduce((acc, day) => {
      acc[day] = { lunch: false, dinner: false };
      return acc;
    }, {}),
  );

  const onGoBack = () => {
    // 🟢 INTERNAL SETUP FLOW
    if (typeof onBack === "function") {
      onBack();
      return;
    }

    // 🔵 ROUTE BASED FLOW
    if (location.state?.from === "meals") {
      navigate("/profile/meals");
      return;
    }

    // 🛑 FALLBACK
    navigate(-1);
  };
  const addWeekly = () => {
    setWeekly((prev) => [
      ...prev,
      { id: crypto.randomUUID(), price: "", days: "" },
    ]);
  };

  const deleteWeekly = (index) => {
    setWeekly((prev) => prev.filter((_, i) => i !== index));
  };

  const addMonthly = () => {
    setMonthly((prev) => [
      ...prev,
      { id: crypto.randomUUID(), price: "", days: "" },
    ]);
  };

  const deleteMonthly = (index) => {
    setMonthly((prev) => prev.filter((_, i) => i !== index));
  };

  const [serviceImages, setServiceImages] = useState([]);

  // Only cleanup on unmount
  useEffect(() => {
    return () => {
      serviceImages.forEach((img) => {
        if (img.type === "upload" && img.preview) {
          URL.revokeObjectURL(img.preview);
        }
      });
    };
  }, []);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 200, tolerance: 5 },
    }),
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setServiceImages((prev) => {
      const draggedIndex = prev.findIndex((img) => img.id === active.id);
      const overIndex = prev.findIndex((img) => img.id === over.id);

      // Make a copy of the array
      const newArr = [...prev];

      // Remove the dragged item
      const [dragged] = newArr.splice(draggedIndex, 1);

      // Insert it at the new position
      newArr.splice(overIndex, 0, dragged);

      // Ensure the first image is always marked as cover
      newArr.forEach((img, index) => {
        img.isCover = index === 0;
      });

      return newArr;
    });
  };

  const handleDeviceUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const MAX_IMAGES = 10;
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    const allowedExtensions = ["jpg", "jpeg", "png", "webp"];

    if (serviceImages.length + files.length > MAX_IMAGES) {
      toast.error("Maximum 10 images allowed");
      e.target.value = "";
      return;
    }

    const validFiles = files.filter((file) => {
      const extension = file.name.split(".").pop().toLowerCase();

      // ✅ Extension validation
      if (!allowedExtensions.includes(extension)) {
        toast.error(
          `${file.name} not supported. Only JPG, JPEG, PNG, WEBP allowed`,
        );
        return false;
      }

      // ✅ Size validation
      if (file.size > MAX_SIZE) {
        toast.error(`${file.name} exceeds 5MB limit`);
        return false;
      }

      return true;
    });

    const withIds = validFiles.map((file) => ({
      id: crypto.randomUUID(),
      type: "upload",
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
      isNew: true,
    }));

    if (withIds.length) {
      setServiceImages((prev) => {
        if (prev.length > 0 && prev[0].isCoverReplacement) {
          const rest = prev.slice(1);
          return [withIds[0], ...rest];
        } else {
          return [...prev, ...withIds];
        }
      });
    }

    e.target.value = "";
  };

  // Extra Items
  const [extraItems, setExtraItems] = useState([]);
  const [newExtra, setNewExtra] = useState({ name: "", price: "" });
  const [showExtraModal, setShowExtraModal] = useState(false);
  const initialImagesRef = useRef([]);
  const [mealName, setMealName] = useState(" ");
  const [description, setDescription] = useState(" ");
  const [trailValue, setTrailValue] = useState("");
  const [lunchCutoff, setLunchCutoff] = useState(null);
  const [removedImages, setRemovedImages] = useState([]);
  const [dinnerCutoff, setDinnerCutoff] = useState(null);

  useEffect(() => {
    dispatch(getExtraItems())
      .unwrap()
      .then((res) => {
        const extraItemData = res.data.extra_items;

        const formatted = extraItemData.map((item) => ({
          id: item.id,
          name: item.name,
          price: item.amounts,
          selected: false,
        }));

        setExtraItems(formatted);
      });
  }, [dispatch]);

  const deleteExtraItem = (id) => {
    setExtraItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, selected: false } : item,
      ),
    );
  };

  const convertTo24Hour = (timeObj) => {
    if (!timeObj || !timeObj.hour || !timeObj.minute) return "";

    let hour = parseInt(timeObj.hour, 10);
    let minute = parseInt(timeObj.minute, 10);
    const period = timeObj.period;

    if (period === "PM" && hour !== 12) {
      hour += 12;
    }

    if (period === "AM" && hour === 12) {
      hour = 0;
    }

    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  };

  const convertTo12HourObject = (timeStr) => {
    if (!timeStr) return null;

    const [hourStr, minute] = timeStr.split(":");
    let hour = parseInt(hourStr, 10);
    let period = "AM";

    if (hour >= 12) {
      period = "PM";
      if (hour > 12) hour -= 12;
    }

    if (hour === 0) {
      hour = 12;
    }

    return {
      hour: String(hour).padStart(2, "0"),
      minute,
      period,
    };
  };

  // ALL LOGIC OF API
  useEffect(() => {
    const payload = {
      meal_id: meal_id,
    };
    // console.log("The meal id under useEffect is :", payload);
    dispatch(getMealDetailById(payload))
      .unwrap()
      .then((res) => {
        // console.log(
        //   "The res of getting meals detail as per id is : ",
        //   res.data,
        // );

        if (res.data?.extra_item_ids?.length) {
          setSelectedExtraIds(res.data.extra_item_ids);
        }

        const mealsName = res.data?.meal_name;
        setMealName(mealsName);
        // console.log("The meal name is :", mealsName);
        const description = res.data?.meal_description;
        setDescription(description);

        const trialData = res.data?.trial_serving_cost;
        setTrailValue(trialData);

        const lunchCut = res.data?.lunch_cutoff_time;
        setLunchCutoff(convertTo12HourObject(lunchCut));

        // console.log("The lunch cut is :", lunchCutoff);

        const dinnerCut = res.data?.dinner_cutoff_time;
        setDinnerCutoff(convertTo12HourObject(dinnerCut));

        if (res.data?.weekly_plans?.length) {
          const weeklyFormatted = res.data.weekly_plans.map((plan) => ({
            id: plan.id,
            price: plan.plan_amount,
            days: plan.order_count,
          }));

          setWeekly(weeklyFormatted);
        }

        if (res.data?.monthly_plans?.length) {
          const monthlyFormatted = res.data.monthly_plans.map((plan) => ({
            id: plan.id,
            price: plan.plan_amount,
            days: plan.order_count,
          }));
          setMonthly(monthlyFormatted);
        }

        if (res.data?.meal_other_images?.length) {
          const ImagesData = res.data.meal_other_images.map((img) => {
            return {
              id: crypto.randomUUID(),
              type: img.type,
              imageId: img.id,
              galleryId: img.gallery_image_id || null,
              name: img.name || img.image_url?.split("/").pop(),
              preview: img.image_url,
              isCover: img.is_cover_image === 1,
              isNew: false,
            };
          });

          const coverIndex = ImagesData.findIndex((img) => img.isCover);

          if (coverIndex > 0) {
            const coverImage = ImagesData.splice(coverIndex, 1)[0];
            ImagesData.unshift(coverImage);
          }

          initialImagesRef.current = ImagesData.map((img) => ({
            imageId: img.imageId,
            type: img.type,
          }));

          setServiceImages(ImagesData);

          // console.log("The img data from useEffect is :", serviceImages);
        }
        // console.log("The image id from backend is :", imageId);

        if (res.data?.availability_data?.length) {
          const toggleState = {};
          const foodState = {};

          res.data.availability_data.forEach((item) => {
            const day = item.key.charAt(0).toUpperCase() + item.key.slice(1);

            toggleState[day] = item.isActive || item.isLunch || item.isDinner;

            foodState[day] = {
              lunch: item.isLunch,
              dinner: item.isDinner,
            };
          });

          setDayToggle((prev) => ({ ...prev, ...toggleState }));
          setFoodType((prev) => ({ ...(prev || {}), ...foodState }));
        }
      });
  }, [meal_id, dispatch]);

  useEffect(() => {
    if (!extraItems.length) return;

    setExtraItems((prev) =>
      prev.map((item) => ({
        ...item,
        selected: selectedExtraIds.includes(item.id),
      })),
    );
  }, [selectedExtraIds]);
   

  const buildAvailabilityData = () => {
    return days.map((day) => {
      const active = dayToggle[day];

      return {
        key: day.toLowerCase(),
        isActive: active,
        isLunch: active ? foodType[day]?.lunch || false : false,
        isDinner: active ? foodType[day]?.dinner || false : false,
      };
    });
  };

  const handleOnServiceSave = async () => {
    try {
      const uploadableImages = serviceImages.filter(
        (img) => img.isNew && img.type === "upload" && img.file,
      );

      const initialImages = initialImagesRef.current;

      const imagesChanged =
        removedImages.length > 0 ||
        serviceImages.some((img) => img.isNew) ||
        JSON.stringify(serviceImages.map((i) => i.imageId)) !==
          JSON.stringify(initialImages.map((i) => i.imageId));

      let uploadedNames = [];
      if (uploadableImages.length > 0) {
        const fd = new FormData();
        fd.append("type", "meals/other_images");
        uploadableImages.forEach((img) => fd.append("images[]", img.file));

        const uploadRes = await dispatch(addNewImages(fd)).unwrap();
        if (!uploadRes.success) {
          toast.error(uploadRes.message || "Image upload failed");
          return;
        }

        uploadedNames = uploadRes?.data?.temp_images || [];
        uploadableImages.forEach((img, index) => {
          img.uploadedName = uploadedNames[index];
        });
      }
      let meal_cover_images = null;

      if (serviceImages.length > 0) {
        const cover = serviceImages[0];

        if (cover.type === "upload") {
          meal_cover_images = {
            type: "upload",
            name: cover.isNew ? cover.uploadedName : cover.name,
          };
        }

        if (cover.type === "gallery") {
          meal_cover_images = {
            type: "gallery",
            id: cover.imageId,
            name: cover.name || "",
          };
        }
      }

      const meal_other_images = serviceImages
        .slice(1)
        .filter((img) => img.isNew)
        .map((img) => {
          if (img.type === "upload") {
            return {
              type: "upload",
              name: img.uploadedName,
            };
          }

          if (img.type === "gallery") {
            return {
              type: "gallery",
              id: img.imageId,
              name: img.name || "",
            };
          }

          return null;
        })
        .filter(Boolean);

      // ✅ Removed images
      const removed_other_images = removedImages.map((img) => ({
        type: img.type,
        id: img.id,
        name: img.name,
      }));

      const weekly_plans = (weekly || [])
        .filter((w) => w.price && w.days)
        .map((w) => ({
          id: typeof w.id === "number" ? w.id : undefined,
          order_count: Number(w.days),
          plan_amount: Number(w.price),
        }));

      const monthly_plans = (monthly || [])
        .filter((m) => m.price && m.days)
        .map((w) => ({
          id: typeof w.id === "number" ? w.id : undefined,
          order_count: Number(w.days),
          plan_amount: Number(w.price),
        }));

      const extra_item_ids = (extraItems || [])
        .filter((item) => item.selected)
        .map((item) => item.id);

      const payload = {
        meal_id: Number(meal_id),
        meal_name: mealName.trim(),
        meal_description: description.trim(),
        trial_serving_cost: Number(trailValue),
        availability_data: buildAvailabilityData(),
        lunch_cutoff_time: convertTo24Hour(lunchCutoff),
        dinner_cutoff_time: convertTo24Hour(dinnerCutoff),
        weekly_plans,
        monthly_plans,
        meal_cover_images: meal_cover_images || null,
        meal_other_images: meal_other_images.length ? meal_other_images : [],
        removed_other_images: removed_other_images,
        extra_item_ids: extra_item_ids,
      };

      // console.log("🔥 FINAL PAYLOAD:", payload);
      const res = await dispatch(addOrUpdateMealDetail(payload)).unwrap();

      if (!res?.success) {
        toast.error(res?.message || "Meal save failed");
        return;
      }

      toast.success(res.message || "Meal saved successfully");

      if (location.state?.from === "meals") {
        navigate("/profile/meals");
        return;
      } else {
        onBack();
        return;
      }
    } catch (err) {
      const errorMessage =
        err?.data?.message || err?.message || err || "Failed to save meal";
      toast.error(errorMessage);
      console.error(err);
    }
  };

  const hasAtLeastOneImage = serviceImages.length > 0;
  return (
    <section className="relative p-4 overflow-hidden lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100">
      <DecorativeSquares />
      {/* 🔽 YOUR EXISTING CONTENT */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10 bg-white shadow-md mt-2 md:mt-8 p-8">
        <div className="relative flex items-center h-10">
          {/* Back Button – Left */}
          <button
            onClick={onGoBack}
            className="absolute left-0 flex items-center"
          >
            <FaArrowLeft className="text-lg" />
          </button>

          {/* Title – Center */}
          <h1 className="mx-auto text-[#191919] font-bold text-base md:text-lg lg:text-xl">
            Edit Meal Plan
          </h1>
        </div>

        {/* ================= Meal Name ================= */}
        <div className="max-w-7xl mx-auto">
          <TextInput
            label="Meal Name"
            name="mealname"
            required={true}
            value={mealName}
            onChange={(e) => setMealName(e.target.value)}
          />
        </div>

        {/* ================= Upload Meal Photo ================= */}
        <div className="max-w-7xl mx-auto space-y-2">
          <p className="text-sm  font-medium">Upload Meal Photograph</p>
          <UploadTriggerCard
            icon={GalleryImg}
            required={true}
            text="Upload your meal photo or brand image"
            buttonText="Upload"
            onClick={() => setShowUploadOptions(true)}
          />
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          className="hidden"
          onChange={handleDeviceUpload}
        />

        {/* ================= Images Preview ================= */}
        {serviceImages.length > 0 && (
          <div className="max-w-7xl mx-auto">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={serviceImages.map((i) => i.id)}
                strategy={rectSortingStrategy}
              >
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4 touch-none">
                  {serviceImages.map((item, i) => (
                    <SortableImageItem
                      key={item.id} // ✅ always unique
                      id={item.id} // for DnD
                      img={item}
                      isCover={i === 0}
                      onRemove={() => {
                        setServiceImages((prev) => {
                          const removed = prev[i];

                          if (removed && !removed.isNew) {
                            setRemovedImages((old) => [
                              ...old,
                              {
                                type: removed.type,
                                id: removed.imageId,
                                name: removed.name || "",
                              },
                            ]);
                          }

                          return prev.filter((_, idx) => idx !== i);
                        });
                      }}
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>

            <p className="mt-3 text-sm text-gray-600">
              Note: The first image will appear as your cover image.You can
              click and hold to drag images and change their order.
            </p>
          </div>
        )}

        {/* ================= Meal Description ================= */}
        <div className="max-w-7xl mx-auto">
          <InputBase
            required={true}
            type="textarea"
            label={"Meal Description"}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={2}
          />
        </div>

        {/* ================= Days & Meal Types ================= */}
        <div className="max-w-7xl mx-auto space-y-6">
          <div className="flex gap-2 items-center mb-2">
            <p className="font-medium">
              Select Days of Operation{" "}
              <span className="text-red-500 ml-1">*</span>{" "}
            </p>
            <CiCircleInfo
              size={18}
              className="cursor-pointer text-gray-400"
              data-tooltip-id="desc-info"
              data-tooltip-content="Select the days and meal types available for your customers."
            />
            <Tooltip
              id="desc-info"
              place="top"
              className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
            />
          </div>

          {days.map((day) => (
            <div
              key={day}
              className="flex flex-nowrap items-center justify-between md:justify-start bg-gray-50 rounded-lg gap-0 md:gap-4"
            >
              <div>
                <p className="w-16 text-sm">{day}</p>
              </div>

              {/* 3️⃣ Disable checkboxes if toggle is off */}
              <div className="flex gap-2 items-center justify-end flex-wrap">
                <ToggleBtn
                  isOn={dayToggle[day]}
                  size={40}
                  onChange={(newValue) => {
                    setDayToggle((prev) => {
                      // OFF → checkbox reset
                      if (!newValue) {
                        setFoodType((ft) => ({
                          ...(ft || {}),
                          [day]: { lunch: false, dinner: false },
                        }));
                      }
                      return { ...prev, [day]: newValue };
                    });
                  }}
                />

                <Checkbox
                  variant="pill"
                  label="Lunch"
                  name={`lunch-${day}`}
                  icon={<GoSun />}
                  checked={foodType?.[day]?.lunch || false}
                  disabled={!dayToggle[day]}
                  onChange={(e) =>
                    setFoodType((prev) => ({
                      ...prev,
                      [day]: { ...prev[day], lunch: e.target.checked },
                    }))
                  }
                />

                <Checkbox
                  variant="pill"
                  label="Dinner"
                  name={`dinner-${day}`}
                  icon={<BsMoonStars />}
                  checked={foodType?.[day]?.dinner || false}
                  disabled={!dayToggle[day]}
                  onChange={(e) =>
                    setFoodType((prev) => ({
                      ...prev,
                      [day]: { ...prev[day], dinner: e.target.checked },
                    }))
                  }
                />
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-7xl mx-auto px-0 md:px-3 overflow-hidden">
          <p className="font-medium">
            Select Plan type <span className="text-red-500 ml-1">*</span>{" "}
          </p>
          <fieldset className="border rounded-xl p-4 overflow-hidden mt-4">
            <legend className="px-2 text-sm text-gray-700">
              Trial (1 Meal)
            </legend>

            <div className="space-y-2">
              <p className="text-sm text-gray-600">Price</p>

              {/* ONE ROW – NO SIDE SCROLL */}
              <div className="flex items-center  flex-nowrap rounded-lg w-full">
                {/* $ */}
                <div className="px-3 py-2 bg-red-50 text-red-500 font-medium border-r shrink-0">
                  {currencySymbol}
                </div>

                {/* INPUT */}
                <input
                  type="text"
                  value={trailValue}
                  onChange={(e) => setTrailValue(e.target.value)}
                  className="flex-1 min-w-0 px-2 py-2 w-32 md:w-full outline-none text-sm"
                />

                {/* BADGE */}
                <div className="px-2 py-1 mr-2 bg-red-50 text-red-500 text-[11px] rounded-full whitespace-nowrap shrink-0">
                  {currencySymbol}
                  {trailValue}/Order
                </div>
              </div>
            </div>
          </fieldset>
        </div>

        <div className="max-w-7xl mx-auto px-0 md:px-3">
          <fieldset className="border rounded-2xl p-4 mt-4 bg-white">
            <legend className="px-3 text-sm font-medium text-gray-700">
              Weekly
            </legend>

            <div className="space-y-5">
              {weekly.map((item, index) => (
                <div key={item.id} className="space-y-2">
                  <p className="text-sm font-medium text-gray-600">Price</p>

                  {/* ROW */}
                  <div className="flex items-center gap-2 w-full border rounded-xl p-2 overflow-hidden">
                    {/* $ + Price */}
                    <div className="flex items-center gap-1 shrink-0">
                      <div className="px-3 py-2 bg-red-50 text-red-500 font-medium border rounded-md">
                        {currencySymbol}
                      </div>
                      <input
                        type="text"
                        value={item.price}
                        onChange={(e) =>
                          setWeekly((prev) =>
                            prev.map((w, i) =>
                              i === index ? { ...w, price: e.target.value } : w,
                            ),
                          )
                        }
                        className="w-12 sm:w-24 px-2 py-2 text-center text-sm border rounded-md"
                      />
                    </div>

                    {/* Days */}
                    <input
                      type="text"
                      value={item.days}
                      onChange={(e) =>
                        setWeekly((prev) =>
                          prev.map((w, i) =>
                            i === index ? { ...w, days: e.target.value } : w,
                          ),
                        )
                      }
                      className="w-10 sm:w-20 px-2 py-2 text-center text-sm border rounded-md"
                    />

                    <div className="flex-1 min-w-0 flex justify-center">
                      <span className="px-3 py-1 bg-red-50 text-red-500 text-xs font-medium rounded-full whitespace-nowrap">
                        {currencySymbol}
                        {item.price && item.days
                          ? (Number(item.price) / Number(item.days)).toFixed(2)
                          : 0}{" "}
                        / Order
                      </span>
                    </div>

                    {/* Delete */}
                    <button
                      className="shrink-0 text-red-500"
                      onClick={() => deleteWeekly(index)}
                    >
                      <MdDeleteOutline size={22} />
                    </button>
                  </div>
                </div>
              ))}
              <button
                type="button"
                onClick={addWeekly}
                className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
              >
                <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                  <MdAdd size={15} />
                </span>
                Add more
              </button>

              <p className="text-[#242021] text-sm  text-start max-w-7xl mx-auto">
                Note: Add multiple weekly pricing options if your rates vary by
                the number of days.
              </p>
            </div>
          </fieldset>
        </div>

        <div className="max-w-7xl mx-auto px-0 md:px-3">
          <fieldset className="border rounded-2xl p-4 mt-4 bg-white">
            <legend className="px-3 text-sm font-medium text-gray-700">
              Monthly
            </legend>

            <div className="space-y-5">
              {monthly.map((item, index) => (
                <div key={item.id} className="space-y-2">
                  <p className="text-sm font-medium text-gray-600">Price</p>

                  {/* ROW */}
                  <div className="flex items-center gap-2 w-full border rounded-xl p-2 overflow-hidden">
                    {/* $ + Price */}
                    <div className="flex items-center gap-1 shrink-0">
                      <div className="px-3 py-2 bg-red-50 text-red-500 font-medium border rounded-md">
                        {currencySymbol}{" "}
                      </div>
                      <input
                        type="text"
                        value={item.price}
                        onChange={(e) =>
                          setMonthly((prev) =>
                            prev.map((w, i) =>
                              i === index ? { ...w, price: e.target.value } : w,
                            ),
                          )
                        }
                        className="w-12 sm:w-24 px-2 py-2 text-center text-sm border rounded-md"
                      />
                    </div>

                    {/* Days */}
                    <input
                      type="text"
                      value={item.days}
                      onChange={(e) =>
                        setMonthly((prev) =>
                          prev.map((w, i) =>
                            i === index ? { ...w, days: e.target.value } : w,
                          ),
                        )
                      }
                      className="w-10 sm:w-20 px-2 py-2 text-center text-sm border rounded-md"
                    />

                    {/* Spacer (IMPORTANT for center alignment) */}
                    <div className="flex-1 min-w-0 flex justify-center">
                      <span className="px-3 py-1 bg-red-50 text-red-500 text-xs font-medium rounded-full whitespace-nowrap">
                        {currencySymbol}
                        {item.price && item.days
                          ? (Number(item.price) / Number(item.days)).toFixed(2)
                          : 0}{" "}
                        / Order
                      </span>
                    </div>

                    {/* Delete */}
                    <button
                      className="shrink-0 text-red-500"
                      onClick={() => deleteMonthly(index)}
                    >
                      <MdDeleteOutline size={22} />
                    </button>
                  </div>
                </div>
              ))}

              <button
                type="button"
                className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
                onClick={addMonthly}
              >
                <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                  <MdAdd size={15} />
                </span>
                Add more
              </button>
              <p className="text-[#242021] text-sm  text-start max-w-7xl mx-auto">
                Note: Add multiple Monthly pricing options if your rates vary by
                the number of days.
              </p>
            </div>
          </fieldset>
        </div>

        <div className="max-w-7xl mx-auto px-0 md:px-3">
          {/* Card Container */}
          <div className="relative w-full rounded-3xl p-[1px] bg-gradient-to-br from-orange-200/40 via-transparent to-orange-100/40">
            <div className="rounded-3xl bg-white/90 backdrop-blur-xl p-8 shadow-[0_25px_70px_rgba(0,0,0,0.06)] border border-white/60 transition-all duration-300">
              {/* Header */}
              <div className="flex items-start justify-between mb-8">
                <div>
                  <h2 className="text-xl font-semibold text-gray-900 tracking-tight">
                    Cutoff Time
                  </h2>
                </div>

                <div className="flex items-center gap-3">
                  <CiCircleInfo
                    size={18}
                    className="cursor-pointer text-gray-400 hover:text-[#FB6742] transition"
                    data-tooltip-id="desc-info"
                    data-tooltip-content="Your customer will not be able to place or cancel orders after this cutoff time."
                  />

                  <Tooltip
                    id="desc-info"
                    place="top"
                    className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
                  />
                </div>
              </div>

              {/* Time Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <TimeRangePicker12
                  label="Lunch Cutoff"
                  variant="single"
                  value={lunchCutoff}
                  onChange={setLunchCutoff}
                />

                <TimeRangePicker12
                  label="Dinner Cutoff"
                  variant="single"
                  value={dinnerCutoff}
                  onChange={setDinnerCutoff}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-3 overflow-hidden">
          <div className="flex gap-2 items-center mb-2">
            <p className="font-medium">Set extra items</p>
            <button
              onClick={() => setShowExtraModal(true)}
              className="flex items-center gap-2 text-sm font-medium text-[#FF6943] hover:underline ml-auto"
            >
              <span className="flex items-center justify-center w-3 h-3 border border-[#FF6943] rounded-sm">
                <MdAdd size={15} />
              </span>
              Add extra item
            </button>
          </div>

          <div className="space-y-2 mt-4">
            {extraItems.filter((item) => item.selected).length === 0 && (
              <p className="text-sm text-gray-400 text-center">
                No extra items selected
              </p>
            )}

            {extraItems
              .filter((item) => item.selected)
              .map((item, index) => (
                <div
                  key={item.id}
                  className={`flex items-center justify-between px-3 py-2 rounded-lg ${
                    index % 2 === 0 ? "bg-gray-50" : "bg-[#FFFAF8]"
                  }`}
                >
                  <div className="text-sm font-medium">{item.name}</div>

                  <div className="flex gap-4 items-center">
                    <div className="px-2 py-1 text-[#FF6943] font-bold">
                      {currencySymbol}
                      {item.price}
                    </div>

                    <button
                      onClick={() => deleteExtraItem(item.id)}
                      className="text-[#FF6943]"
                    >
                      <MdDeleteOutline size={22} />
                    </button>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="flex justify-center items-center md:justify-between gap-4">
          <SecondaryBtn
            btnName="Cancel"
            clickEvent={() => navigate(-1)}
            extraClass="-mt-0"
          />

          <PrimaryBtn
            btnName="Save Meal Plan"
            clickEvent={handleOnServiceSave}
            isLoading={isMealLoading}
            disabled={!hasAtLeastOneImage}
          />
        </div>
      </div>

      {/* ================= Upload Modal ================= */}
      {showUploadOptions && (
        <div className="fixed inset-0 bg-[#0F172A]/60 flex items-center justify-center z-50 animate-fadeIn">
          <div className="relative w-full max-w-lg mx-4">
            {/* Modal Card */}
            <div className="relative bg-white rounded-3xl p-8 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.25)] border border-gray-100">
              {/* Accent Top Bar */}

              {/* Title Section */}
              <div className="text-center mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 tracking-tight">
                  Upload Photos
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  Choose how you want to add your images
                </p>
              </div>

              {/* Options */}
              <div className="space-y-4">
                {/* Upload From Device */}
                <button
                  onClick={() => {
                    setShowUploadOptions(false);
                    fileInputRef.current.click();
                  }}
                  className="group relative w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                            bg-gradient-to-r from-[#FF7043]/20 to-[#FF5722]/50 
                            text-white font-medium shadow-lg 
                            "
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/20">
                      <img
                        src={UploadIcon}
                        alt="uploadIcon"
                        className="w-6 h-6"
                      />
                    </div>
                    <span className="text-base text-black">
                      Upload from device
                    </span>
                  </div>

                  <span className="opacity-70 group-hover:translate-x-1 transition-transform duration-300">
                    →
                  </span>
                </button>

                {/* Choose From Library */}
                <button
                  onClick={() => {
                    setShowUploadOptions(false);
                    setShowLibrary(true);
                  }}
                  className="group w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                            border border-gray-200 bg-white 
                            text-gray-700 font-medium 
                            "
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-100">
                      <img
                        src={GalleryImg}
                        alt="galleryicon"
                        className="w-6 h-6"
                      />
                    </div>
                    <span className="text-base">Choose from photo library</span>
                  </div>

                  <span className="text-gray-400 group-hover:translate-x-1 transition-transform duration-300">
                    →
                  </span>
                </button>
              </div>

              {/* Footer */}
              <div className="mt-8 text-center">
                <button
                  onClick={() => setShowUploadOptions(false)}
                  className="text-sm text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLibrary && (
        <MealUploadLibraryModal
          selectedImages={serviceImages
            .filter((img) => img.type === "gallery")
            .map((img) => img.imageId)}
          onClose={() => setShowLibrary(false)}
          onSelect={(selectedPhotos) => {
            const MAX_IMAGES = 10;

            if (serviceImages.length >= MAX_IMAGES) {
              toast.error("Maximum 10 images allowed");
              return;
            }

            setServiceImages((prev) => {
              const existingIds = prev
                .filter((img) => img.type === "gallery")
                .map((img) => img.imageId);

              const newImages = selectedPhotos
                .filter((photo) => !existingIds.includes(photo.id))
                .map((photo) => ({
                  id: crypto.randomUUID(),
                  type: "gallery",
                  preview: photo.image,
                  imageId: photo.id,
                  name: photo.image.split("/").pop(),
                  isNew: true,
                }));

              return [...prev, ...newImages];
            });

            setShowLibrary(false);
          }}
        />
      )}

      {showExtraModal &&
        (isMealLoading ? (
          <ExtraItemsModalShimmer />
        ) : (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-xl w-full max-w-sm p-4 space-y-4 relative">
              {/* CLOSE BUTTON */}
              <button
                onClick={closeModal}
                className="absolute right-3 top-3 text-gray-500 hover:text-black text-lg"
              >
                ✕
              </button>

              <h2 className="text-lg font-semibold text-center">
                Add Extra Items
              </h2>

              {/* ITEMS LIST */}
              <div className="max-h-64 overflow-y-auto space-y-1">
                {extraItems.map((item, index) => (
                  <div
                    key={index}
                    className={`flex justify-between items-center px-3 py-2 rounded ${
                      index % 2 === 0 ? "bg-gray-50" : "bg-[#FFFAF8]"
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={item.selected || false}
                        onChange={() =>
                          setExtraItems((prev) =>
                            prev.map((el) =>
                              el.id === item.id
                                ? { ...el, selected: !el.selected }
                                : el,
                            ),
                          )
                        }
                        className="w-4 h-4 accent-green-500"
                      />

                      <span className="text-sm font-medium">{item.name}</span>
                    </div>

                    <span className="text-[#FF6943] font-bold text-sm">
                      {currencySymbol}
                      {item.price}
                    </span>
                  </div>
                ))}
              </div>

              {/* ADD NEW ITEM BUTTON */}
              {!showAddInline && (
                <p
                  className="text-xs text-center text-[#FF6943] cursor-pointer"
                  onClick={() => setShowAddInline(true)}
                >
                  Add New Extra Item
                </p>
              )}

              {/* ADD ITEM FORM */}
              {showAddInline && (
                <div className="flex gap-2 items-center mt-2">
                  <input
                    type="text"
                    placeholder="Item Name"
                    value={newExtra.name}
                    onChange={(e) =>
                      setNewExtra((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    className="flex-1 px-3 py-2 border rounded-md outline-none text-sm"
                  />

                  <div className="flex items-center border rounded-md px-2 py-1 text-sm">
                    {currencySymbol}
                    <input
                      type="number"
                      value={newExtra.price}
                      onChange={(e) =>
                        setNewExtra((prev) => ({
                          ...prev,
                          price: e.target.value,
                        }))
                      }
                      className="w-12 px-1 py-1 text-right outline-none"
                    />
                  </div>

                  <button
                    onClick={addExtraItem}
                    className="bg-[#FF6943] text-white px-3 py-2 rounded-md"
                  >
                    +
                  </button>
                </div>
              )}

              {/* CONFIRM BUTTON */}
              <button
                onClick={closeModal}
                className="w-full bg-[#FF6943] text-white py-2 rounded-lg mt-2"
              >
                Add Items
              </button>
            </div>
          </div>
        ))}
    </section>
  );
};

export default EditMeal;
